import React from "react";

const CREATORS_IFRAME_PAGE_LINK = "https://tours.lifeat.io/creators";
export default function CreatorsPage() {
    return (
        <div className="info-page">
            <iframe src={CREATORS_IFRAME_PAGE_LINK} frameBorder={0} />
        </div>
    );
}
